import script from "./AddMemberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMemberModal.vue?vue&type=script&setup=true&lang=js"

import "./AddMemberModal.vue?vue&type=style&index=0&id=c27673dc&lang=scss&scoped=true"
script.__scopeId = "data-v-c27673dc"

export default script